import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/Register.css';
import { api } from '../helpers/apiConfig';

const initialState = {
  name: '',
  username: '',
  email: '',
  password: '',
  whatsapp: ''
};

const Register = () => {
  const [form, setForm] = useState(initialState);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const userData = {
      name: form.name,
      username: form.username,
      email: form.email,
      password: form.password,
      whatsapp: form.whatsapp
    };
    try {
      const registerUrl = api('/api/users/register');
      console.log('POST register ->', registerUrl);
      const res = await fetch(registerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData)
      });

      const payload = await res.json().catch(() => ({}));
      if (!res.ok) {
        // Show user-friendly Spanish messages
        const errorMessages = {
          'UserExists': payload.detail?.includes('Email')
            ? 'Este correo electrónico ya tiene una cuenta registrada'
            : 'Este nombre de usuario ya está en uso',
          'MissingFields': 'Por favor completa todos los campos requeridos'
        };
        const friendlyMsg = errorMessages[payload.errorcode] || payload.detail || payload.msg || `Error en el registro`;
        throw new Error(friendlyMsg);
      }

      navigate(`/verify-email`, { state: { email: form.email, from: location.state?.from } });
    } catch (err) {
      console.error('Error en registro:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Crear tu perfil Tappy</h2>
        {error && <div className="register-error">{error}</div>}
        <input name="name" value={form.name} onChange={handleChange} placeholder="Nombre completo" required />
        <input name="username" value={form.username} onChange={handleChange} placeholder="Username único" required />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" required />
        <PhoneInput
          country={'cl'}
          value={form.whatsapp}
          onChange={value => setForm({ ...form, whatsapp: value })}
          inputProps={{
            name: 'whatsapp',
            required: false,
            autoFocus: false,
            placeholder: 'WhatsApp (opcional)'
          }}
          specialLabel=""
          inputStyle={{ width: '100%' }}
        />
        <input name="password" type="password" value={form.password} onChange={handleChange} placeholder="Contraseña" required />
        <button type="submit" disabled={loading}>{loading ? 'Creando...' : 'Crear perfil'}</button>
        <p className="register-login">
          ¿Ya tienes cuenta? <Link to="/login" state={{ from: location.state?.from }}>Inicia sesión aquí</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
